/*
 * File: PageHeader.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 16 Nov 2021 1:05:56 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Row, Space, Spin } from 'antd';
import { ReactComponent as MdsiLogo } from 'common/assets/mdsi-logo.svg';
import { BlockLoader } from 'components/atoms/BlockLoader';
import { UserDropdown } from 'components/molecules/UserDropdown';
import Cookies from 'js-cookie';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReduxState } from 'redux/rootReducer';
import { useGetApplicationByIdQuery } from 'redux/services/useFreddyCadabbyServices';

const styles: InlineStylesModel = {
  appName: {
    cursor: 'pointer',
    fontSize: isMobileOnly ? '0.75rem' : '24px',
    marginLeft: isMobileOnly ? '8px' : '16px',
    marginRight: isMobileOnly ? '8px' : '16px',
    // marginTop: '2px',
    color: 'gray'
  },
  mainContainer: {
    color: 'white'
  },
  link: {
    color: 'gray'
  },
  wrapper: {
    maxWidth: '1920px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '0 50px'
  }
};

export const PageHeader = (): JSX.Element => {
  const { user } = useSelector((state: ReduxState) => state.app);
  const { data: application, isError } = useGetApplicationByIdQuery(process.env.REACT_APP_APPLICATION_ID);

  const handleRemoveCookie = (): void => {
    Cookies.remove(`${process.env.REACT_APP_COOKIE_PREFIX}_acuity_context`);
  };

  return (
    <Row style={styles.wrapper} justify="space-between">
      <Col>
        <Row style={styles.mainContainer} align="middle" justify="center">
          <Col>
            <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL} onClick={handleRemoveCookie}>
              <Row align="middle">
                <MdsiLogo height="65" width="65" />
              </Row>
            </a>
          </Col>
          <Col>
            <div style={styles.appName}>
              <Space>
                <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL} onClick={handleRemoveCookie} style={styles.link}>
                  Acuity
                </a>
                <span>|</span>
                <Link to="/" style={styles.link}>
                  <Spin indicator={<BlockLoader direction="loader loader--slideUp" />} spinning={false}>
                    {!isError ? application?.name : 'unable to retrieve application name'}
                  </Spin>
                </Link>
              </Space>
            </div>
          </Col>
        </Row>
      </Col>
      <Col>
        <Col>
          <Row align="middle" style={styles.userMenu}>
            {user?.name?.toUpperCase()}
            <UserDropdown />
          </Row>
        </Col>
      </Col>
    </Row>
  );
};
